import { render, staticRenderFns } from "./StudentHistoryDialogMobile.vue?vue&type=template&id=362ea295&scoped=true"
import script from "./StudentHistoryDialogMobile.vue?vue&type=script&lang=js"
export * from "./StudentHistoryDialogMobile.vue?vue&type=script&lang=js"
import style0 from "./StudentHistoryDialogMobile.vue?vue&type=style&index=0&id=362ea295&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "362ea295",
  null
  
)

export default component.exports